export default "__VITE_ASSET__IZ_z3rEH__"